<template>
  <div class="quote-status-detail-wrapper zhenyun-theme">
    <!-- 草稿状态 -->
    <div class="status-describe" v-if="status == 1">
      <el-link type="primary" style="color: #3062f8;cursor:text" :underline="false"
        >报价草稿</el-link
      >
      <div class="status-button-box">
        <el-button
          type="primary"
          @click="handleSubmit"
          v-if="[5, 13].includes(detailInfo.rfqStatus)"
          >提交报价</el-button
        >
        <el-button
          @click="handleGoEdit"
          v-if="[5, 13].includes(detailInfo.rfqStatus)"
          >修改报价</el-button
        >
      </div>
    </div>
    <!-- 已提交状态 -->
    <div class="status-describe" v-if="status == 2">
      <template v-if="detailInfo.rfqStatus == 12">
        <el-link type="primary" style="color: #3b9aff; cursor:text" :underline="false"
          >报价已提交，当前询盘已停止接收报价</el-link
        >
        <div class="status-button-box">
          <contractPopover :contractMap="contractMap" v-model="popoverVisible">
            <el-button
              type="primary"
              slot="reference"
              style="margin-right: 12px"
              size="mini"
              @click="getContactInfo(detailInfo.rfqId)"
              :loading="loadingContactInfo"
            >
              <i class="iconfont icon-call" style="font-size: 14px"></i>
              联系采购</el-button
            >
          </contractPopover>
          <el-button
            @click="handleWithdraw"
            v-if="[5, 13].includes(detailInfo.rfqStatus)"
            >撤回报价</el-button
          >
        </div>
      </template>
      <template v-else-if="detailInfo.rfqStatus == 11">
        <el-link type="primary" style="color: #3b9aff;cursor:text" :underline="false"
          >报价已提交，当前询盘已结束</el-link
        >
        <div class="status-button-box">
          <contractPopover :contractMap="contractMap" v-model="popoverVisible">
            <el-button
              type="primary"
              slot="reference"
              style="margin-right: 12px"
              size="mini"
              @click="getContactInfo(detailInfo.rfqId)"
              :loading="loadingContactInfo"
            >
              <i class="iconfont icon-call" style="font-size: 14px"></i>
              联系采购</el-button
            >
          </contractPopover>
        </div>
      </template>
      <template v-else>
        <el-link type="primary" style="color: #3b9aff;cursor:text" :underline="false"
          >报价已提交</el-link
        >
        <div class="status-button-box">
          <contractPopover :contractMap="contractMap" v-model="popoverVisible">
            <el-button
              type="primary"
              slot="reference"
              style="margin-right: 12px"
              size="mini"
              @click="getContactInfo(detailInfo.rfqId)"
              :loading="loadingContactInfo"
            >
              <i class="iconfont icon-call" style="font-size: 14px"></i>
              联系采购</el-button
            >
          </contractPopover>
          <el-button
            type="primary"
            @click="handleGoCreate"
            v-if="[5, 13].includes(detailInfo.rfqStatus)"
            >重新报价</el-button
          >
          <el-button
            @click="handleWithdraw"
            v-if="[5, 13].includes(detailInfo.rfqStatus)"
            >撤回报价</el-button
          >
        </div>
      </template>
    </div>
    <!-- 已候选状态 -->
    <div class="status-describe" v-if="status == 7">
      <el-link type="primary" style="color: #ff7800;cursor:text" :underline="false"
        >报价已候选，请尽快与采购联系沟通报价细节</el-link
      >
      <div class="status-button-box">
        <contractPopover :contractMap="contractMap" v-model="popoverVisible">
          <el-button
            type="primary"
            slot="reference"
            style="margin-right: 12px"
            size="mini"
            @click="getContactInfo(detailInfo.rfqId)"
            :loading="loadingContactInfo"
          >
            <i class="iconfont icon-call" style="font-size: 14px"></i>
            联系采购</el-button
          >
        </contractPopover>

        <el-button
          @click="handleGoCreate"
          v-if="[5, 13].includes(detailInfo.rfqStatus)"
          >重新报价</el-button
        >
        <el-button
          @click="handleWithdraw"
          :loading="withdrawLoading"
          v-if="[5, 13].includes(detailInfo.rfqStatus)"
          >撤回报价</el-button
        >
      </div>
    </div>
    <div class="status-describe" v-if="status == 8">
      <el-link type="primary" style="color: #20b820;cursor:text" :underline="false"
        >报价已接受，请与采购联系确认合作下单</el-link
      >
      <div class="status-button-box">
        <contractPopover :contractMap="contractMap" v-model="popoverVisible">
          <el-button
            type="primary"
            slot="reference"
            style="margin-right: 12px"
            size="mini"
            @click="getContactInfo(detailInfo.rfqId)"
            :loading="loadingContactInfo"
          >
            <i class="iconfont icon-call" style="font-size: 14px"></i>
            联系采购</el-button
          >
        </contractPopover>
      </div>
    </div>
    <!-- 已撤回 -->
    <div class="status-describe" v-if="status == 4 && !detailInfo.awardDetail">
      <span class="chehui-text">报价已撤回</span>
      <div class="status-button-box">
        <el-button
          type="primary"
          @click="handleGoCreate"
          v-if="[5, 13].includes(detailInfo.rfqStatus)"
          >重新报价</el-button
        >
      </div>
    </div>
    <!-- 已撤销-->
    <div class="status-describe" v-if="status == 5">
      <span class="chehui-text">询盘已撤销</span>
    </div>
    <!-- 已拒绝 -->
    <div class="status-describe" v-if="status == 3">
      <div class="reason-box">
        <span class="rejected-text">报价已拒绝</span>
        <p class="rejected-remark">
          {{ detailInfo.reason }}
        </p>
      </div>
      <div class="status-button-box">
        <el-button
          type="primary"
          @click="handleGoCreate"
          v-if="[5, 13].includes(detailInfo.rfqStatus)"
          >重新报价</el-button
        >
      </div>
    </div>
    <!-- 已授盘 -->
    <div class="status-describe" v-if="status == 6">
      <template>
        <el-link type="primary" style="color: #20b820;cursor:text" :underline="false"
          >报价已授盘，请与采购联系确认订单</el-link
        >
        <div class="status-button-box">
          <contractPopover :contractMap="contractMap" v-model="popoverVisible">
            <el-button
              type="primary"
              slot="reference"
              style="margin-right: 12px"
              size="mini"
              @click="getContactInfo(detailInfo.rfqId)"
              :loading="loadingContactInfo"
            >
              <i class="iconfont icon-call" style="font-size: 14px"></i>
              联系采购</el-button
            >
          </contractPopover>
          <el-button @click="handleGoOrderDetail">查看订单</el-button>
        </div>
      </template>
    </div>
    <!-- 这里应该是产品逻辑的问题，status应当是2，但是先这么做，后期迭代 -->
    <div class="status-describe" v-if="detailInfo.awardDetail && status == 4">
      <!-- detailInfo.awardDetail.orderNo 存在说明已经授盘，可以查看订单 -->
      <template v-if="detailInfo.awardDetail && detailInfo.awardDetail.orderNo">
        <el-link type="primary" style="color: #20b820;cursor:text" :underline="false"
          >报价已授盘，请与采购联系确认订单</el-link
        >
        <div class="status-button-box">
          <contractPopover :contractMap="contractMap" v-model="popoverVisible">
            <el-button
              type="primary"
              slot="reference"
              style="margin-right: 12px"
              size="mini"
              @click="getContactInfo(detailInfo.rfqId)"
              :loading="loadingContactInfo"
            >
              <i class="iconfont icon-call" style="font-size: 14px"></i>
              联系采购</el-button
            >
          </contractPopover>
          <el-button @click="handleGoOrderDetail">查看订单</el-button>
        </div>
      </template>
      <template v-else>
        <span class="chehui-text">报价已撤回</span>
        <div class="status-button-box">
          <el-button
            type="primary"
            @click="handleGoCreate"
            v-if="[5, 13].includes(detailInfo.rfqStatus)"
            >重新报价</el-button
          >
        </div>
      </template>
    </div>
    <div
      class="status-step"
      v-if="![1, 3, 4, 5].includes(status) || detailInfo.awardDetail"
    >
      <zhenyunStep
        :stepList="stepList"
        :currentStep="currentStep"
      ></zhenyunStep>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import zhenyunStep from './zhenyun-step.vue'
import {
  withdrawQuoteOrderApi,
  contactInfApi,
  getCheckQuoteApi,
} from '@/utils/api/zhenyun.js'
import contractPopover from './contract-popover.vue'
import { onlineUrl } from '@/utils/config'
export default {
  name: 'quote-status',
  props: {
    status: {
      type: Number,
    },
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    zhenyunStep,
    contractPopover,
  },
  data() {
    return {
      loadingContactInfo: false,
      popoverVisible: false,
      contractMap: {},
      stepList: [],
      currentStep: 0,
      withdrawLoading: false,
    }
  },
  methods: {
    handleGoOrderDetail() {
      if (!this.detailInfo.awardDetail.orderNo) {
        return this.$message.error('订单不存在')
      }
      window.open(
        `${onlineUrl}/purchase-order/supplier/order/${this.detailInfo.awardDetail.orderNo}`,
        '_blank'
      )
      // https://qa-online.haizol.com/purchase-order/supplier/order/H82507081026452
    },
    getContactInfo(id) {
      this.loadingContactInfo = true
      contactInfApi({
        relationId: id,
        compId: this.detailInfo.compInfo.compId,
        source: 1,
        type: 4,
      })
        .then((res) => {
          const { rspResult, data } = res
          if (rspResult.bizCode == 200) {
            data && (data.positionSelectStr = data.position)
            this.contractMap = data || {}
            this.popoverVisible = true
          }
        })
        .finally(() => {
          this.loadingContactInfo = false
        })
    },
    handleSubmit() {
      this.$emit('handleSubmit')
    },
    async handleWithdraw() {
      this.$confirm('确定要撤回报价吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.withdrawApi()
        })
        .catch(() => {})
    },
    async withdrawApi() {
      try {
        this.withdrawLoading = true
        const res = await withdrawQuoteOrderApi({
          rfqQuoteId: this.detailInfo.id,
        })
        this.withdrawLoading = false
        const { rspResult } = res
        if (rspResult.bizCode == 200) {
          this.$message.success('撤回报价成功')
          this.$emit('updateQuoteStatus')
        }
      } catch (error) {
        this.withdrawLoading = false
      }
    },
    handleGoEdit() {
      this.$router.push({
        name: 'update-quote',
        params: {
          id: this.detailInfo.rfqIdAes,
        },
        query: {
          quoteId: this.detailInfo.id,
        },
      })
    },
    async checkQuoteStatus() {
      try {
        const res = await getCheckQuoteApi()
        const { rspResult, data } = res
        return rspResult.bizCode === 200 ? data.flag : false
      } catch (error) {
        return false
      }
    },
    handleGoCreate() {
      this.checkQuoteStatus().then((res) => {
        if (res === true) {
          this.$router.push({
            name: 'created-quote',
            params: {
              id: this.detailInfo.rfqIdAes,
            },
          })
        } else {
          window.open(`${onlineUrl}/supplier-profile?u=1`)
        }
      })
    },
  },
  mounted() {},
  watch: {
    detailInfo: {
      immediate: true,
      handler(val) {
        if (!val) {
          return
        }
        /**
         * 场景太多了，没有业务场景逻辑性，只能判断报价单状态，判断询盘状态然后手动去➕，什么鬼逻辑，服了服了
         * rfqStatus 5 已授盘（可以报价）
         * rfqStatus 6 已授盘（待确认订单）
         * rfqStatus 7 已授盘（授盘）
         * rfqStatus 8 已授盘（接受订单）
         * rfqStatus 9 已授盘（完成订单）
         * rfqStatus 11 已授盘（询盘结束）
         * rfqStatus 12 停止接受报价
         *
         * ***/
        if (val.status == 2 && [5, 6, 7, 8, 9,12, 13].includes(val.rfqStatus)) {
          this.stepList = [
            {
              label: '已报价',
              time: val.submitTime
                ? moment(val.submitTime).format('YYYY-MM-DD HH:mm:ss')
                : '',
            },
            {
              label: '已授盘',
              time: val?.awardDetail?.createTime
                ? moment(val.awardDetail.createTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                : '',
            },
            {
              label: '完成',
              time: '',
            },
          ]
        }
        // 已报价（询盘结束）
        if (val.status == 2 && val.rfqStatus == 11) {
          this.currentStep = 1
          this.stepList = [
            {
              label: '已报价',
              time: val.submitTime
                ? moment(val.submitTime).format('YYYY-MM-DD HH:mm:ss')
                : '',
            },
            {
              label: '询盘结束',
              time: '',
            },
          ]
        }
        // 已授盘（待确认订单） & 已授盘（接受订单）
        if (val.status == 6 && [6, 7, 8, 9].includes(val.rfqStatus)) {
          if (val.rfqStatus == 6) {
            this.currentStep = 1
          }
          if ([8,9].includes(val.rfqStatus)) {
            this.currentStep = 3
          }
          this.stepList = [
            {
              label: '已报价',
              time: val.submitTime
                ? moment(val.submitTime).format('YYYY-MM-DD HH:mm:ss')
                : '',
            },
            {
              label: '已授盘',
              time: val?.awardDetail?.createTime
                ? moment(moment(val.awardDetail.createTime)).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                : '',
            },
            {
              label: '接受订单',
              time: val?.awardDetail?.supplierOperationTime
                ? moment(val.awardDetail.supplierOperationTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                : '',
            },
            {
              label: '完成',
              time: '',
            },
          ]
        }
        if ([7,8,9].includes(val.rfqStatus) && val.status == 4) {
          this.currentStep = 0
          if (val?.awardDetail?.createTime) {
            this.currentStep = 1
          }
          if (val?.awardDetail?.supplierOperationTime) {
            this.currentStep = 3
          }
          this.stepList = [
            {
              label: '已报价',
              time: val.submitTime
                ? moment(val.submitTime).format('YYYY-MM-DD HH:mm:ss')
                : '',
            },
            {
              label: '已授盘',
              time: val?.awardDetail?.createTime
                ? moment(val.awardDetail.createTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                : '',
            },
            {
              label: '拒绝订单',
              time: val?.awardDetail?.supplierOperationTime
                ? moment(val.awardDetail.supplierOperationTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                : '',
            },
            {
              label: '完成',
              time: '',
            },
          ]
        } else if (val.rfqStatus == 7) {
          this.currentStep = 0
          this.stepList = [
            {
              label: '已报价',
              time: val.submitTime
                ? moment(val.submitTime).format('YYYY-MM-DD HH:mm:ss')
                : '',
            },
            {
              label: '已授盘',
              time: val?.awardDetail?.createTime
                ? moment(val.awardDetail.createTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                : '',
            },
            {
              label: '完成',
              time: '',
            },
          ]
        }
      },
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.quote-status-detail-wrapper {
  margin: 8px 16px 0;
  border-radius: 8px;
  background: #fbfbfb;
  padding: 16px;
  display: flex;
  align-items: center;
  .status-describe {
    flex: 1;
    .reason-box {
      display: flex;
    }
    .status-button-box {
      margin-top: 17px;
    }
  }
  .status-step {
    flex: 1;
    margin-left: 15px;
  }
}
.chehui-text {
  align-self: stretch;
  color: #b4bcc5;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.rejected-text {
  color: #ff081f;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  line-height: 22px;
}
.rejected-remark {
  color: #666666;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  position: relative;
  padding-left: 24px;
  margin-left: 24px;
  // border-left: 1px solid #e9edf1;
}
.rejected-remark::before {
  content: '';
  display: inline-block;
  width: 1px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 2px;
  background: #98a3b7;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -8px;
}
</style>
